import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwarurbaniaonrent() {



  const cardData =
  {
    keyword: 'Pune to Mahabaleshwar Urbania On Rent',
    heading: 'Amruta Travels: Pune to Mahabaleshwar Urbania On Rent',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Pune to Mahabaleshwar Urbania on Rent, providing a luxurious and comfortable journey through the scenic Western Ghats. Our Force Urbania vans are ideal for family vacations, weekend getaways, and corporate retreats, offering plush push-back seats, spacious interiors, air conditioning, and ample luggage capacity for a smooth travel experience. With experienced chauffeurs ensuring safety and punctuality, you can sit back and enjoy the beautiful hill views along the Pune–Mahabaleshwar route. Whether it’s a leisure trip, wedding group travel, or executive outing, Amruta Travels’ Pune to Mahabaleshwar Urbania Rental guarantees premium comfort, reliability, and elegance for your entire journey.',

    top: 'Top Places to Visit in Mahabaleshwar with Amruta Travels',

"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is the heart of Mahabaleshwar, surrounded by lush hills and misty forests. Built in 1842 by Chhatrapati Appasaheb, it offers scenic boating experiences and horse rides along the promenade. Street stalls serving corn, strawberries, and hot snacks add to the charm. Venna Lake is Mahabaleshwar’s most loved spot for families, couples, and nature enthusiasts."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a delightful attraction famous for its strawberry farms, chocolate factory, and fresh fruit products. Visitors enjoy strawberry cream, sandwiches, and refreshing juices in a serene garden setting. The annual Strawberry Festival attracts thousands of tourists. Mapro Garden is Mahabaleshwar’s sweet retreat celebrating fruit, flavor, and freshness."
  },
  {
    "title": "Arthur’s Seat Point",
    "description": "Arthur’s Seat Point offers panoramic views of the Savitri Valley and the deep Konkan Gorge. Known as the ‘Queen of All Points,’ it provides a unique floating illusion when objects thrown down seem to rise up due to air pressure. The spot is a favorite among trekkers and photographers. Arthur’s Seat is Mahabaleshwar’s iconic viewpoint of wonder and beauty."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, built by Chhatrapati Shivaji Maharaj in 1656, is a historic fortress perched atop a hill offering breathtaking views. It was the site of the famous battle between Shivaji Maharaj and Afzal Khan. The fort’s watchtowers, temples, and rugged charm attract history lovers. Pratapgad stands as Mahabaleshwar’s proud symbol of Maratha courage and legacy."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point, shaped like an elephant’s trunk, is one of Mahabaleshwar’s most picturesque spots. It offers sweeping views of the Sahyadri mountains and deep valleys, especially enchanting during sunrise and sunset. The cool breeze and serenity make it ideal for relaxation. It’s Mahabaleshwar’s natural sculpture carved beautifully by time and nature."
  },
  {
    "title": "Lodwick Point",
    "description": "Lodwick Point provides an awe-inspiring view of the Pratapgad Fort and the surrounding greenery. Named after Sir John Lodwick, a marble monument stands here in his memory. The trek to the point is scenic and peaceful, perfect for adventure seekers. Lodwick Point captures Mahabaleshwar’s mix of history, beauty, and serenity."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall cascades from a height of 600 feet, creating a mesmerizing sight amidst dense forests. The viewpoint offers a spectacular panorama of the waterfall and the valley below. The misty environment and rhythmic sound of falling water make it a rejuvenating escape. Lingmala is Mahabaleshwar’s natural wonder for monsoon travelers."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point, the highest spot in Mahabaleshwar at 4,710 feet, is the best place to catch a sunrise. It offers panoramic views of the surrounding hills and plateaus bathed in golden light. Photographers and nature lovers frequent this spot for its tranquil beauty. Wilson Point is Mahabaleshwar’s radiant crown of dawn and peace."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "The Mahabaleshwar Temple, dedicated to Lord Shiva, dates back to the 16th century and is one of the region’s oldest spiritual sites. Its ancient Hemadpanti architecture and the sacred Shiva lingam draw thousands of devotees. The temple holds great mythological importance as the origin of River Krishna. It stands as Mahabaleshwar’s timeless center of divinity and devotion."
  },
  {
    "title": "Kate’s Point & Echo Point",
    "description": "Kate’s Point offers a magnificent view of the Dhom Dam and Krishna Valley, making it one of Mahabaleshwar’s most photographed locations. Nearby Echo Point delights visitors with natural sound reflections. The breezy cliffs and wide vistas make it an ideal picnic and photography spot. Together, they define Mahabaleshwar’s spectacular landscape charm."
  }
],



     "services": [
    {
      "name": "Pune to Mahabaleshwar Urbania On Rent",
      "description": "Pune to Mahabaleshwar Urbania On Rent offers luxurious and reliable travel for families, tourists, and corporate groups heading to the hills. Experience a smooth and scenic ride with comfortable seating, air conditioning, and professional chauffeurs who ensure safety and punctuality. This service is perfect for weekend getaways, family vacations, and group excursions. With flexible rental options and well-maintained vehicles, every journey to Mahabaleshwar becomes relaxed and enjoyable."
    },
    {
      "name": "Urbania Hire Pune to Mahabaleshwar",
      "description": "Urbania Hire Pune to Mahabaleshwar provides convenient mini-bus rental options for groups seeking stress-free mountain travel. The service ensures comfortable interiors, powerful air conditioning, and ample luggage space, making long drives pleasant. Whether it’s a corporate trip, a wedding outing, or a leisure tour, this service guarantees timely pickups and professional drivers familiar with the Pune–Mahabaleshwar route for a truly comfortable journey."
    },
    {
      "name": "Force Urbania Pune Mahabaleshwar",
      "description": "Force Urbania Pune Mahabaleshwar brings together comfort, class, and efficiency for your outstation travel. Designed with advanced suspension, reclining seats, and premium amenities, these vans are ideal for both family and business travelers. The drivers are courteous and experienced in hilly terrains, ensuring a safe and steady drive to Mahabaleshwar’s scenic destinations. With hassle-free booking and transparent pricing, every kilometer feels premium."
    },
    {
      "name": "AC Urbania Pune Mahabaleshwar",
      "description": "AC Urbania Pune Mahabaleshwar service provides an air-conditioned, smooth, and refreshing ride through the Western Ghats. Ideal for all-season travel, the vehicles are equipped with powerful cooling systems, reclining seats, and entertainment facilities. Whether you’re traveling with family or colleagues, this service ensures a relaxed and pleasant experience from Pune to the misty hills of Mahabaleshwar with professional drivers ensuring punctuality."
    },
    {
      "name": "Non AC Urbania Pune Mahabaleshwar",
      "description": "Non AC Urbania Pune Mahabaleshwar is a perfect option for travelers looking for economical yet reliable group transport. The vehicles are well-maintained and spacious, ensuring comfort even without AC. Best suited for short-duration trips, student tours, and local sightseeing, this service provides safety, cleanliness, and punctuality. Affordable pricing and courteous drivers make it an ideal choice for budget travelers."
    },
    {
      "name": "Luxury Urbania Pune Mahabaleshwar",
      "description": "Luxury Urbania Pune Mahabaleshwar caters to travelers who prefer elegance and class in every mile. These premium vans feature leather upholstery, advanced climate control, LED entertainment screens, and smooth rides designed for comfort. Perfect for VIP guests, family holidays, or executive tours, the service ensures punctuality, privacy, and personalized attention throughout your journey from Pune to Mahabaleshwar."
    },
    {
      "name": "Urbania Van for Mahabaleshwar Trip",
      "description": "Urbania Van for Mahabaleshwar Trip offers convenient and scenic travel solutions for those planning a hill-station escape. With wide windows for panoramic views, soft seats, and ample legroom, this service enhances your travel experience. Whether you’re exploring Venna Lake or Mapro Garden, enjoy comfort, flexibility, and safety with trained drivers who know every corner of Mahabaleshwar’s routes."
    },
    {
      "name": "Family Urbania Pune to Mahabaleshwar",
      "description": "Family Urbania Pune to Mahabaleshwar ensures every family trip is filled with comfort, laughter, and togetherness. Spacious interiors, child-friendly features, and smooth rides make it ideal for family vacations. Drivers maintain punctuality and safety while allowing flexible stops for sightseeing and meals. The service guarantees memorable road trips for families seeking a stress-free travel experience."
    },
    {
      "name": "Corporate Urbania Pune to Mahabaleshwar",
      "description": "Corporate Urbania Pune to Mahabaleshwar provides professional transport for company outings, team off-sites, and client visits. With Wi-Fi, comfortable seating, and clean interiors, employees can relax or prepare presentations on the go. Dedicated drivers ensure punctuality and route efficiency, while customized rental packages cater to corporate schedules and needs. It’s a perfect blend of business convenience and leisure comfort."
    },
    {
      "name": "Urbania Booking Pune Mahabaleshwar",
      "description": "Urbania Booking Pune Mahabaleshwar offers an easy and transparent booking system for your travel plans. Customers can select vehicle types, pickup timings, and travel preferences instantly. The service ensures quick confirmations, 24x7 support, and affordable pricing for all types of group trips. Whether it’s a spontaneous weekend plan or a scheduled tour, booking your Urbania is now simple and dependable."
    },
    {
      "name": "Affordable Urbania Pune Mahabaleshwar",
      "description": "Affordable Urbania Pune Mahabaleshwar provides budget-friendly travel solutions without compromising comfort or safety. Ideal for school groups, small businesses, or large families, the service includes well-maintained vehicles and experienced drivers. Passengers enjoy smooth rides through scenic ghats at economical rates, with flexible packages and transparent pricing to suit every budget."
    },
    {
      "name": "Urbania Hire near Me Pune",
      "description": "Urbania Hire near Me Pune ensures quick access to reliable mini-bus rentals for your Mahabaleshwar trip. Whether you need same-day availability or pre-booked comfort, vehicles are always nearby and ready for your convenience. The service offers professional drivers, flexible timings, and comfortable seating, making it ideal for families, offices, and tourist groups looking for nearby Urbania rentals."
    },
    {
      "name": "Force Urbania Tour Pune Mahabaleshwar",
      "description": "Force Urbania Tour Pune Mahabaleshwar offers guided and group tours designed for comfort and discovery. The vehicles come equipped with modern amenities and plenty of luggage space. Drivers double as local guides, ensuring a rich travel experience covering Mahabaleshwar’s top spots like Arthur’s Seat and Wilson Point. Perfect for travel groups, families, and students seeking scenic, organized tours."
    },
    {
      "name": "Urbania Travel Pune Mahabaleshwar",
      "description": "Urbania Travel Pune Mahabaleshwar is a trusted travel partner for scenic journeys across the Sahyadri ranges. Offering luxury seating, clean interiors, and professional service, it’s ideal for couples, families, and groups. The fleet is maintained to the highest standards to guarantee safety and comfort. Enjoy flexible travel plans and personalized service for an unforgettable Pune–Mahabaleshwar experience."
    },
    {
      "name": "17 Seater Urbania Pune Mahabaleshwar",
      "description": "17 Seater Urbania Pune Mahabaleshwar is perfect for medium-sized groups seeking space and convenience. The vehicle features cushioned push-back seats, air conditioning, and ample legroom, making it a favorite among families and office teams. The journey from Pune to Mahabaleshwar becomes smooth and enjoyable, with experienced chauffeurs ensuring every kilometer is covered comfortably and safely."
    },
    {
      "name": "16 Seater Urbania Pune Mahabaleshwar",
      "description": "16 Seater Urbania Pune Mahabaleshwar service provides reliable group transport for school trips, small gatherings, and weekend tours. With a clean, air-conditioned cabin, spacious seats, and modern design, it’s the right balance of comfort and affordability. The drivers are courteous and experienced, ensuring on-time departures and a safe travel experience across the beautiful ghats."
    },
    {
      "name": "Urbania Outstation Pune Mahabaleshwar",
      "description": "Urbania Outstation Pune Mahabaleshwar service specializes in long-distance trips with superior comfort and safety. Ideal for group tours, pilgrimages, and vacations, these mini buses come with adjustable seats and luggage storage. Drivers well-versed with intercity routes guarantee smooth navigation through winding ghats. Enjoy a peaceful journey with reliable service and flexible booking options."
    },
    {
      "name": "Urbania Coach Pune",
      "description": "Urbania Coach Pune provides a fleet of premium mini coaches suited for outstation tours and events like Mahabaleshwar trips. Each coach is equipped with comfortable seating, climate control, and entertainment systems for a pleasurable journey. Experienced chauffeurs ensure safe driving on mountain routes, while the service focuses on punctuality and customer satisfaction from pickup to return."
    }
  ],
  "tableData": [
    ["Pune to Mahabaleshwar Urbania On Rent", "Urbania Hire Pune to Mahabaleshwar"],
    ["Force Urbania Pune Mahabaleshwar", "AC Urbania Pune Mahabaleshwar"],
    ["Non AC Urbania Pune Mahabaleshwar", "Luxury Urbania Pune Mahabaleshwar"],
    ["Urbania Van for Mahabaleshwar Trip", "Family Urbania Pune to Mahabaleshwar"],
    ["Corporate Urbania Pune to Mahabaleshwar", "Urbania Booking Pune Mahabaleshwar"],
    ["Affordable Urbania Pune Mahabaleshwar", "Urbania Hire near Me Pune"],
    ["Force Urbania Tour Pune Mahabaleshwar", "Urbania Travel Pune Mahabaleshwar"],
    ["17 Seater Urbania Pune Mahabaleshwar", "16 Seater Urbania Pune Mahabaleshwar"],
    ["Urbania Outstation Pune Mahabaleshwar", "Urbania Coach Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mahabaleshwar Urbania On Rent",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers reliable Urbania rental services for Pune to Mahabaleshwar trips, perfect for comfortable group travel to this scenic hill station."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania vans provide ample space and ergonomic seating, ensuring a relaxing journey on the Pune to Mahabaleshwar route."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "We regularly service and sanitize our vehicles to guarantee safety, hygiene, and comfort throughout your trip."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy clear pricing with no hidden fees, offering great value for your Pune to Mahabaleshwar travel."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose rental durations and packages tailored for your Pune to Mahabaleshwar trip, including round trips and multi-day packages."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are skilled and familiar with the Pune to Mahabaleshwar route, ensuring a safe, punctual, and smooth journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, itinerary changes, and travel assistance."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your Pune to Mahabaleshwar Urbania rental easily online or via phone, with prompt vehicle delivery and reliable service."
  }
]










  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer Urbania on rent for Pune to Mahabaleshwar trips?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides Urbania vehicles on rent for comfortable and safe travel from Pune to Mahabaleshwar.',
  },
  {
    question: 'How can I book an Urbania for Pune to Mahabaleshwar travel with Amruta Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What amenities are available in the Urbania vehicles for Pune to Mahabaleshwar trips?',
    answer: 'Our Urbania vehicles come with comfortable seating, air conditioning, and essential safety features for a pleasant journey.',
  },
  {
    question: 'Are the drivers experienced in Pune to Mahabaleshwar routes for Urbania hires?',
    answer: 'Yes, our drivers are professional, experienced, and knowledgeable about the Pune to Mahabaleshwar route to ensure a safe and timely trip.',
  },
  {
    question: 'Can Urbania vehicles be hired for one-way or round trips between Pune and Mahabaleshwar?',
    answer: 'Absolutely. We offer flexible booking options for both one-way and round trips between Pune and Mahabaleshwar.',
  },
  {
    question: 'Is the Urbania rental service for Pune to Mahabaleshwar available 24×7?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for Pune to Mahabaleshwar Urbania rentals to suit your travel plans.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Mahabaleshwar Urbania hires?',
    answer: 'All vehicles are sanitized thoroughly before each trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for Pune to Mahabaleshwar Urbania rentals?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the Pune to Mahabaleshwar Urbania rental period?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your Pune to Mahabaleshwar Urbania rental.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Deepak Shinde',
    feedback: 'The Pune to Mahabaleshwar Urbania from Amruta Travels was very comfortable. The driver was knowledgeable and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Kulkarni',
    feedback: 'Excellent service for Pune to Mahabaleshwar Urbania hire. Highly recommend Amruta Travels for safe and comfortable travel.',
    rating: 5,
  },
];










































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Urbania On Rent",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/27.jpg",
  "description": "Rent a Force Urbania from Pune to Mahabaleshwar with Amruta Travels Pvt. Ltd. Comfortable AC and Non-AC Urbania mini bus services for family trips, corporate travel, and outstation tours. Affordable and reliable Urbania hire.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "12784"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/pune-to-mahabaleshwar-urbania-on-rent"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Mahabaleshwar Urbania On Rent | Comfortable Urbania Hire Pune | Amruta Travels</title>
  <meta
    name="description"
    content="Rent a Force Urbania from Pune to Mahabaleshwar with Amruta Travels Pvt. Ltd. Comfortable AC and Non-AC Urbania mini bus services for family trips, corporate travel, and outstation tours. Affordable and reliable Urbania hire."
  />
  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Urbania On Rent, Urbania Hire Pune to Mahabaleshwar, Force Urbania Pune Mahabaleshwar, AC Urbania Pune Mahabaleshwar, Non AC Urbania Pune Mahabaleshwar, Luxury Urbania Pune Mahabaleshwar, Urbania Van for Mahabaleshwar Trip, Family Urbania Pune to Mahabaleshwar, Corporate Urbania Pune to Mahabaleshwar, Urbania Booking Pune Mahabaleshwar, Affordable Urbania Pune Mahabaleshwar, Urbania Hire near Me Pune, Force Urbania Tour Pune Mahabaleshwar, Urbania Travel Pune Mahabaleshwar, 17 Seater Urbania Pune Mahabaleshwar, 16 Seater Urbania Pune Mahabaleshwar, Urbania Outstation Pune Mahabaleshwar, Urbania Coach Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwarurbaniaonrent;